import {
  jb_breadcrumbs_css_default
} from "./chunk.WBYZ65O2.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  o
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-breadcrumbs/jb-breadcrumbs.ts
var JbBreadcrumbs = class extends i {
  firstUpdated() {
    if (!this._items) return;
    this._items[this._items.length - 1].current = true;
    if (!this.removeLastDuplicate || this._items.length < 2) return;
    if (this._items[this._items.length - 1].text === this._items[this._items.length - 2].text) {
      this._items[this._items.length - 2].remove();
    }
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "breadcrumb",
      interaction_text: e.detail.linkTag.innerText
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      ${this.ariaLabels?.label ? b`<h2 class="sr-only">${this.ariaLabels.label}</h2>` : A}
      <nav
        aria-label=${this.ariaLabels?.label ?? A}
        @jb-link:clicked=${this._tracking}
      >
        <slot name="backlink"></slot>
        <div role="list">
          <slot name="items"></slot>
        </div>
      </nav>
    `;
  }
};
JbBreadcrumbs.styles = [reset_css_default, jb_breadcrumbs_css_default];
__decorateClass([
  n({ type: Object })
], JbBreadcrumbs.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Boolean })
], JbBreadcrumbs.prototype, "removeLastDuplicate", 2);
__decorateClass([
  o({ slot: "items" })
], JbBreadcrumbs.prototype, "_items", 2);
JbBreadcrumbs = __decorateClass([
  customElement("jb-breadcrumbs")
], JbBreadcrumbs);

export {
  JbBreadcrumbs
};
